import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion as MuiAccordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { ReactNode } from "react";
import { Typography } from "../../components";

export const Accordion = (props: { 
  label: ReactNode; 
  children: ReactNode; 
  defaultExpanded?: boolean; 
}) => {
  return (
    <MuiAccordion defaultExpanded={props.defaultExpanded}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>{props.label}</Typography>
      </AccordionSummary>

      <AccordionDetails>
        <Typography>{props.children}</Typography>
      </AccordionDetails>
    </MuiAccordion>
  );
};
